import { gql } from '@apollo/client';

export const GET_TENANTS_FOR_EMAIL = gql`
  query getTenantsForEmail($email: String!) {
    getTenantsForEmail(email: $email) {
      id
      name
    }
  }
`;
